import React, { useEffect, useState } from 'react';
import { Table, Statistic, Tag } from 'antd';
import moment from 'moment';
// import {VscEye} from 'react-icons/vsc'
// import PlatformIconRender from '../../../Common/PlatformIconRender';
// import { Link } from 'react-router-dom';
import CurrencyIcon from '../../../Common/CurrencyIcon';
const CampaignTxnComponent = ({ txnObj }) => {
  const [camps, setCamps] = useState({
    // pager:{
    //     page:1,
    //     total:0,
    //     limit:10
    // },
    data: [],
  });
  useEffect(() =>{
    setCamps({
      ...camps,
      // pager:{
      //     ...camps.pager,
      //     page:campObj.page,
      //     limit:campObj.limit,
      //     total:campObj.totalDocs
      // },
      data: txnObj.map((txn, index)=>{
        return {
          key: index,
          id: txn._id || 'N/A',
          paymentMethod: txn.paymentMethod || 'N/A',
          amount: txn.amount || 0,
          walletId: txn.walletId || 'N/A',
          updatedAt: moment(txn.updatedAt).format('Do MMM YYYY'),
          status: txn.status || 'N/A',
          transactionType: txn.transactionType,
        };
      }),
    });
  }, [txnObj]);
  // @note: table columns setup
  const columns = [
    {
      title: 'Payment Method',
      dataIndex: 'paymentMethod',
    },
    {
      with: 100,
      title: 'Amount',
      dataIndex: 'amount',
      render: (v) =>(
        <>
          {CurrencyIcon()}<Statistic className="custom_number_format"
            value={v}
            precision={2}/>
        </>
      ),
    },
    {
      title: 'Wallet ID',
      dataIndex: 'walletId',
    },
    {
      width: 150,
      title: 'Updated At',
      dataIndex: 'updatedAt',
      align: 'center',
      render: (v) =>(
        <>
          <div style={{ fontSize: '12px' }}>{v}</div>
        </>
      ),
    },
    {
      title: 'Transaction Type',
      dataIndex: 'transactionType',
    },
    {
      width: 80,
      title: 'Status',
      dataIndex: 'status',
      align: 'center',
      render: (_v) =>{
        switch (_v) {
        case 'success':
          return <Tag color="green"
            className="m-0">{_v}</Tag>;
        default:
          return <Tag color="gold"
            className="m-0" >{_v}</Tag>;
        }
      },
    },
  ];
    // @note: page changing if more than
  const changePage = (page) =>{
    const { pager } = camps;
    // companyOverview(page,pager.limit)
  };
  return (
    <div className="common_card p-3 txn_history h-100">
      <div className="row">
        <div className="col-md-12 mt-4">
          <Table
            columns={columns}
            dataSource={camps.data || []}
            pagination={{
              //    current:camps.pager.page,
              //     total:camps.pager.total,
              //     showSizeChanger:false,
              //     showQuickJumper:true,
              //     onChange: (v) => changePage(v)
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default CampaignTxnComponent;
